// src/components/TazdoneProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/new/Tazdone.jpeg";
import thumb1 from "../assets/images/New-Products/new/Tazdone.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("ingredients");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Tazdone </h2>
              <p className="sub-heading text-muted">Potent Effective Steroid for treatment of Moderate to Severe Plaque Psoriasis.</p>
              <h5>Product Overview</h5>
              <p>
                Tazdone Gel is a scientifically advanced topical therapy designed for the effective management of Acne Vulgaris and Plaque Psoriasis. These dermatological conditions are characterized by abnormal keratinocyte proliferation, inflammation, and altered skin cell differentiation.
              </p>
              <p>
                Tazdone Gel is a scientifically advanced topical therapy designed for the effective management of Acne Vulgaris and Plaque Psoriasis. These dermatological conditions are characterized by abnormal keratinocyte proliferation, inflammation, and altered skin cell differentiation.
              </p>
              <p>
                Tazdone™ targets these core mechanisms by normalizing skin cell turnover, reducing inflammation, and controlling hyperproliferation, thereby improving overall skin health and appearance.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Tazdone ?</span>
                </h3>
                <p>
                  Take 1 tablet twice daily, preferably after meals or as directed by your physician. For optimal results, continue the therapy for a minimum of 8 weeks.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "ingredients", "application", "precautions", "adverse-effects", "highlights"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "precautions"
                          ? "PRECAUTIONS"
                          : tab === "adverse-effects"
                            ? "ADVERSE EFFECTS"
                            : tab === "highlights"
                              ? "HIGHLIGHTS"
                              : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Third-generation receptor-selective retinoid</li>
                    <li>Dual indication: Acne vulgaris &amp; Plaque psoriasis</li>
                    <li>Triple action: Comedolytic, anti-inflammatory &amp; anti-proliferative</li>
                    <li>Acts at gene expression level for targeted therapy</li>
                    <li>Fast-absorbing gel base suitable for oily skin</li>
                    <li>Can be combined with corticosteroids or antibiotics</li>
                    <li>Enhances treatment efficacy and patient compliance</li>
                  </ul>
                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Apply once daily, preferably at night</li>
                      <li>Use on clean and dry skin</li>
                      <li>Apply a thin layer to affected area</li>
                      <li>Short-contact therapy: Leave for 10–30 minutes, then wipe off</li>
                      <li>Avoid contact with eyes, mouth, and mucous membranes</li>
                    </ul>
                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>

                    <ul>
                      <li><strong>Tazarotene (0.1%)</strong> - A third-generation topical retinoid with high receptor specificity for RAR-β and RAR-γ.</li>
                      <li>Normalizes keratinocyte differentiation</li>
                      <li>Reduces hyperproliferation of skin cells</li>
                      <li>Controls inflammation</li>
                      <li>Promotes comedolysis in acne</li>
                      <li>Suppresses T-lymphocyte activity in psoriasis</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>

                    <ul>
                      <li>Not recommended in pregnancy</li>
                      <li>Avoid use in children below 12 years</li>
                      <li>Use sunscreen and avoid direct sunlight exposure</li>
                      <li>Apply moisturizer to reduce irritation</li>
                      <li>Avoid sensitive areas</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "adverse-effects" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Mild irritation</li>
                      <li>Dryness</li>
                      <li>Redness</li>
                      <li>Burning or stinging sensation</li>
                      <li>Increased photosensitivity</li>
                    </ul>
                  </p>
                </div>
              )}
              {activeTab === "highlights" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Proven efficacy in reducing acne lesions and psoriatic plaques</li>
                      <li>Visible improvement as early as 1 week</li>
                      <li>Sustained results up to 12 weeks post-treatment</li>
                      <li>Comparable efficacy to topical corticosteroids with longer-lasting benefits</li>
                      <li>Well-tolerated with minimal local irritation</li>
                    </ul>
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
